var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleStackedChart',{attrs:{"name":_vm.$t('Chart__NumberOfDoctors__name'),"sheets":_vm.sheets}})}
var staticRenderFns = []

export { render, staticRenderFns }